// src/config.js
const variables = {
  API_BASE_URL: "https://simplepass.com.ar",
  //API_BASE_URL: "http://localhost:8080",
};

export default variables;